function BlogGridPlaceholder({ count }) {
  let result = [];
  for (let i = 0; i < count; i++)
    result.push(
      <div className="col" key={i}>
        <div className="card" aria-hidden="true">
          <svg
            className="bd-placeholder-img card-img-top"
            width="100%"
            height="180"
            xmlns="http://www.w3.org/2000/svg"
            role="img"
            aria-label="Placeholder"
            preserveAspectRatio="xMidYMid slice"
            focusable="false"
          >
            <title>Placeholder</title>
            <rect width="100%" height="100%" fill="#868e96"></rect>
          </svg>

          <div className="card-body">
            <div className="h5 card-title placeholder-glow">
              <span className="placeholder col-10 placeholder-lg"></span>
            </div>
            <p className="card-text placeholder-glow">
              <span className="placeholder col-4 placeholder-sm"></span>
            </p>
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
              <span className="placeholder col-4 ms-3"></span>
              <span className="placeholder col-4"></span>
              <span className="placeholder col-6 ms-3"></span>
              <span className="placeholder col-8"></span>
            </p>
          </div>
        </div>
      </div>
    );
  return (
    <div className="row row-cols-1 row-cols-md-3 g-4 px-lg-5">{result}</div>
  );
}

export default BlogGridPlaceholder;
